const miniCartSectionId = document
  .querySelector("cart-content")
  .getAttribute("section-id");

/**
 * Change an item in the cart
 * @param {Object|Array} items [{ id, quantity }]
 * @param {Object} options object of callbacks
 */
window.changeCart = (change, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  const sections =
    "sections" in options
      ? [miniCartSectionId, ...options.sections]
      : [miniCartSectionId];

  window.theme
    .fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...change, sections: sections.join() }),
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 422) {
        if (options?.onError) {
          options.onError(response);
        }

        return;
      }

      const updateCart = new CustomEvent("updateCart", {
        detail: {
          cart: response,
          data: options.data,
        },
      });
      document.dispatchEvent(updateCart);

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch(console.error);
};

/**
 * Remove an item from the cart
 * @param {Object|Array} items [{ id, quantity }]
 * @param {Object} options object of callbacks
 */
window.updateCart = (updates, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }

  const sections =
    "sections" in options
      ? [miniCartSectionId, ...options.sections]
      : [miniCartSectionId];

  window.theme
    .fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...updates, sections: sections.join() }),
    })
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 422 && response.message === "Cart Error") {
        if (options?.onError) {
          options.onError(response);
        }

        return;
      }

      const updateCart = new CustomEvent("updateCart", {
        detail: {
          cart: response,
          data: options.data,
        },
      });
      document.dispatchEvent(updateCart);

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch(console.error);
};

/**
 * Add an item to cart
 * @param {Object|Array} items [{ id, quantity }]
 * @param {Object} options object of callbacks
 */
window.addToCart = (items, options = {}) => {
  if (options?.onBeforeAdd) {
    options.onBeforeAdd();
  }
  if (!Array.isArray(items)) {
    items = [items];
  }
  const data = {
    items: [...items],
    sections: miniCartSectionId,
  };

  window.theme
    .fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
    .then((response) => {
      if (response.ok) {
        return response.json();
      }

      throw new Error("Cart error", response);
    })
    .then((response) => {
      const sections = response.sections;

      window.theme
        .fetch("/cart.js", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.json())
        .then((response) => {
          const updateCart = new CustomEvent("updateCart", {
            detail: {
              cart: { ...response, sections },
              data: options.data,
            },
          });
          document.dispatchEvent(updateCart);
        });

      if (options?.onAfterAdd) {
        options.onAfterAdd(response);
      }
    })
    .catch((error) => {
      if (options?.onError) {
        options.onError();
      }

      console.error(error);
    });
};
